import { Decoration_Type } from 'ricos-schema';
import type { TiptapEditorPlugin } from 'ricos-types';
import { createShortcut } from 'ricos-types';
import { RESOLVERS_IDS } from 'wix-rich-content-toolbars-v3/libs/resolvers-ids';

import BoldIcon from './BoldIcon';
import { BOLD_BUTTON_DATA_HOOK } from './data-hooks';
import { bold } from './extension';

export const pluginBold: TiptapEditorPlugin = {
  type: Decoration_Type.BOLD,
  config: {},
  tiptapExtensions: [bold],
  shortcuts: [
    createShortcut({
      name: Decoration_Type.BOLD,
      description: 'ShortcutsSheet_Formatting_Bold',
      keys: { macOs: 'Meta+B', windows: 'Ctrl+B' },
      command({ editorCommands }) {
        editorCommands.toggleInlineStyle('bold');
      },
      group: 'ShortcutsSheet_Section_Formatting',
      enabled: true,
    }),
  ],

  textButtons: [
    {
      id: Decoration_Type.BOLD,
      type: 'toggle',
      presentation: {
        dataHook: BOLD_BUTTON_DATA_HOOK,
        tooltip: 'BoldButton_Tooltip',
        icon: BoldIcon,
      },
      attributes: {
        visible: RESOLVERS_IDS.ALWAYS_VISIBLE,
        active: RESOLVERS_IDS.IS_TEXT_CONTAINS_BOLD,
        disabled: RESOLVERS_IDS.IS_NODE_SELECTED,
      },
      command:
        ({ editorCommands }) =>
        () => {
          editorCommands.toggleInlineStyle('bold');
          return true;
        },
    },
  ],
};
